module.exports = __webpack_public_path__ + "img/notice_bg.b1599caa.png";